import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isArray, snakeCase, includes } from 'lodash';

import ToggleSwitchWithTextAndLabel from 'v-c/Forms/CompositeComponents/ToggleSwitchWithTextAndLabel';
import { ROLES } from 'component-utilities/roles/rolesHelper';

import DialogSelector from '../components/DialogSelector';

import styles from './tabs.scss';

const BASE_KEY = 'components.templates.edit_user';

export default class RolesGroupsStatusTab extends Component {
    static validateFormValues = ({ form }) => {
        const { roles = [] } = form;

        return {
            isFormErrors: !roles.length,
        };
    };

    static propTypes = {
        loginAttemptRestrictionEnabled: PropTypes.bool,
        rolesModalOptions: PropTypes.shape({
            open: PropTypes.func.isRequired,
            close: PropTypes.func.isRequired,
            type: PropTypes.string.isRequired,
        }).isRequired,
        reactForm: PropTypes.shape({
            values: PropTypes.object.isRequired,
            fields: PropTypes.object.isRequired,
        }).isRequired,
        getMessage: PropTypes.func.isRequired,
        allowedRoles: PropTypes.array.isRequired,
        isLoggedInUser: PropTypes.bool.isRequired,
        protectedRoles: PropTypes.array,
        status: PropTypes.string.isRequired,
    };

    static defaultProps = {
        isProcessing: false,
        loginAttemptRestrictionEnabled: false,
        protectedRoles: [],
    };

    constructor(props) {
        super(props);

        this.userRoles = Object.keys(ROLES)
            .filter(role => includes(props.allowedRoles, ROLES[role].name))
            .reduce((all, role) => {
                const { name, tag } = ROLES[role];

                all.push({
                    id: name,
                    tag,
                    value: props.getMessage(`components.modals.user_roles.${snakeCase(name)}.title`),
                    isProtected: includes(props.protectedRoles, name),
                });

                return all;
            }, []);
    }

    onUnlock = () => {
        this.props.reactForm.fields.isLocked.change(false);
    };

    onOpenModal = () => {
        const { rolesModalOptions, protectedRoles } = this.props;

        rolesModalOptions.open(rolesModalOptions.type, {
            individualOptions: {
                updateRoles: this.saveRolesChanges,
            },
            disabledRole: this.disabledRole,
            selectedRoles: this.props.reactForm.values.roles,
            protectedRoles,
            userRoles: this.userRoles,
            from: 'RolesGroupsStatusTab',
        });
    };

    get disabledRole() {
        if (this.props.isLoggedInUser) {
            return ['archiveAdministrator'];
        }

        return false;
    }

    toggleActive = () => {
        const { fields } = this.props.reactForm;

        fields.active.change(!fields.active.value);
    };

    saveRolesChanges = (newValues) => {
        this.props.rolesModalOptions.close({ from: 'RolesGroupsStatusTab ' });

        this.props.reactForm.fields.roles.change(newValues);
    };

    render() {
        const {
            getMessage,
            reactForm: {
                fields: { roles, active, isLocked },
            },
            loginAttemptRestrictionEnabled,
            status,
        } = this.props;

        if (!isArray(roles.value)) {
            return null;
        }

        return (
            <div className={`roles-section ${styles['accordion-content']}`}>
                <DialogSelector
                    widgetId="roles"
                    selectedValues={roles.value}
                    list={this.userRoles}
                    onOpenModal={this.onOpenModal}
                    getMessage={getMessage}
                />
                <div className={styles['status-toggle-container']}>
                    <div data-toggle="account-enable">
                        <ToggleSwitchWithTextAndLabel
                            label={getMessage(`${BASE_KEY}.account_status`)}
                            enabledText={getMessage(`${BASE_KEY}.status.enabled`)}
                            disabledText={getMessage(`${BASE_KEY}.status.disabled`)}
                            enabled={active.value}
                            toggleDisabled={!!status}
                            onToggle={this.toggleActive}
                        />
                    </div>
                    {loginAttemptRestrictionEnabled && (
                        <div data-toggle="account-lock">
                            <ToggleSwitchWithTextAndLabel
                                label={getMessage(`${BASE_KEY}.login_status`)}
                                enabledText={getMessage(`${BASE_KEY}.status.unlocked`)}
                                disabledText={getMessage(`${BASE_KEY}.status.locked`)}
                                enabled={!isLocked.value}
                                toggleDisabled={!isLocked.value}
                                onToggle={this.onUnlock}
                                redDisabled
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
